import { SchemaType } from '@/common/models';

/**
 * Inside CardResp
 */
export class ContractResp {
  public address = '';
  public contractStandard = '';
  public contractType: ContractType = ContractType.Issue;
  public name = '';
  public description = '';
  public image = '';
  public startOn = '';
  public endOn = '';
  public createdOn = '';
  public issueAmount?: number = undefined;
  public redeemAmount?: number = undefined;
  public isMemberTrigger = false;
  public isTriggerOnClick = false;
  public schema = SchemaType.None;
  public isVoucher = false;
  public recentExecCount?: number = undefined;
  public voucherDesc?: string = undefined;
  public limit: ContractLimit = {};
}

class ContractLimit {
  public perDayCount? = undefined;
  public perCusCount? = undefined;
}

export enum ContractType {
  Issue = 'Issue',
  Redeem = 'Redeem',
  Voucher = 'Voucher'
}
